<style lang="less" scoped>
@bg_color: #ffffff;
@bg_color_footer: #414141;
@color_footer: #ffffff;

.container {
  width: 100%;
  height: 100%;
  background-color: @bg_color;
}
.logo {
  background-repeat: no-repeat;
  background-position: center left;
}
.search-bar {
  text-align: right;
  &:before {
    content: " ";
    display: inline-block;
    width: 1px;
    height: 100%;
    vertical-align: middle;
  }
}
.search-bar-item {
  margin-left: 5px;
}
.search-bar-icon {
  font-size: 30px;
  color: #084a95;
  vertical-align: middle !important;
  cursor: pointer;
}
.main {
  padding: 0;
  background-color: #efefef;
  max-height: 100%;
  // height: calc(100vh - 50px);
  overflow-y: scroll;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  // overflow-x: hidden;
}
.footer {
  color: @color_footer;
  a {
    color: @color_footer;
  }
  padding: 0;
  background-color: @bg_color_footer;
}

.footer-title {
  font-size: 1rem;
}

.footer-link,
.footer-title {
  line-height: 2;
  margin-left: 30px;
  position: relative;
}
.footer-link {
  font-size: 0.6rem;
}

.footer-icon {
  position: absolute;
  left: -30px;
  top: 8px;
}
.icon-shipping {
  top: 2px;
  left: -40px;
  font-size: 28px;
}
.tabbar-height {
  height: 50px;
  background: #f0f0f0;
}
.tabbar {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  z-index: 998;
  font-size: 10px;
  .icon {
    width: 25px;
    height: 25px;
  }
}
.search-input {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  .search-input-view {
    width: 100%;
    background: #fff;
    display: flex;
    padding: 10px 0;
    align-items: center;
    justify-content: center;
    /deep/.el-input {
      width: 70%;
    }
  }
}
</style>

<template>
  <el-container class="container flex">
    <el-header class="header container-fixed flex flex-cc shadow" style="height:50px;padding:0">
      <!-- <el-row>
        <el-col :span="12" class="logo" @click.native="goHome">
          <img :src="logoUrl" style="width:100%" @click.native="goHome"/>
        </el-col>
        <el-col :span="12" class="search-bar">
          <svg-icon class="search-bar-item search-bar-icon" icon-class="search" @click.native="showSearchInputView" />
        </el-col>
      </el-row> -->
      <div class="flex flex-cc" style="height:50px;background:white;padding: 0 20px;">
        <el-row>
          <el-col :span="12" class="logo" @click.native="goHome">
            <img :src="logoUrl" style="width:100%" />
          </el-col>
          <el-col :span="12" class="search-bar">
            <svg-icon class="search-bar-item search-bar-icon" icon-class="search" @click.native="showSearchInputView"/>
          </el-col>
        </el-row>
      </div>

    </el-header>

    <div class="search-input" v-if="showSearchInput" @click="showSearchInput = false">
      <div class="flex flex-cc" style="height:50px;background:white;padding: 0 20px;">
        <el-row>
          <el-col :span="12" class="logo" @click="goHome">
            <img :src="logoUrl" style="width:100%" />
          </el-col>
          <el-col :span="12" class="search-bar">
            <svg-icon class="search-bar-item search-bar-icon" icon-class="search" />
          </el-col>
        </el-row>
      </div>
      
      <div class="search-input-view " @click.stop="">
        <div class="flex row flex-all-center" style="width:100%;">
          <el-input  placeholder="请输入搜索关键词" v-model="keyword" @keyup.enter.native="handleSearch"></el-input>
          <el-button style="margin-left:10px;" type="primary" @click="handleSearch">搜索</el-button>
        </div>
        
      </div>
    </div>
    <el-main class="main">
      <AppMain :isShowCates="isShowCates" />
    <el-footer
      class="footer"
      height="auto"
      v-if="showHelp"
    >
      <div
        class="container-fixed"
        style="padding: 1rem"
      >
        <el-row :gutter="30">
          <el-col
            v-for="linkItem in footerLinks"
            :key="linkItem.title"
            :span="12"
          >
            <p class="footer-title">
              <svg-icon
                class="footer-icon"
                :class="'icon-' + linkItem.icon"
                :icon-class="linkItem.icon"
              />
              {{linkItem.title}}
            </p>
            <p
              v-for="link in linkItem.links"
              :key="link.title"
              class="footer-link"
            >
              <a :href="link.url">
                {{link.title}}
              </a>
            </p>
            <el-button
              v-if="linkItem.icon == 'phone'"
              icon="el-icon-service"
              plain
              style="margin: 10px 25px"
              @click="openOLService"
            >联系客服</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col
            v-for="linkItem in footerLinks2"
            :key="linkItem.title"
            :span="12"
          >
            <p class="footer-title">
              <svg-icon
                class="footer-icon"
                :class="'icon-' + linkItem.icon"
                :icon-class="linkItem.icon"
              />
              {{linkItem.title}}
            </p>
            <p
              v-for="link in linkItem.links"
              :key="link.title"
              class="footer-link"
            >
              <a :href="link.url">
                {{link.title}}
              </a>
            </p>
          </el-col>
        </el-row>
      </div>
      <div style="height: 50px"></div>
    </el-footer>
    </el-main>

    <div v-if="showTabbar" class="tabbar-height tabbar flex row flex-sa flex-cc">
      <div class="flex col flex-cc" v-for="(item, index) in tabbars" :key="index">
        <router-link :to="{name: item.url }" class="flex col flex-cc">
          <img :src="tabbarIndex == index ? item.iconSelect : item.icon" class="icon">
          <span :style="{ color: tabbarIndex == index ? '#144685' : '#bfbfbf' }">{{ item.name }}</span>
        </router-link>
      </div>
    </div>
  </el-container>
</template>

<script>
import lodash from 'lodash'

import { AppMain } from './components'
import { createNamespacedHelpers, mapState } from 'vuex'
import config from '@/config'
const { mapGetters: cartMapGetters } = createNamespacedHelpers('cart')

const footerLinks = [
  ['phone', config.customerService.tel, [config.customerService.time]],
  ['help', '购物帮助', ['关于企业内购|#', '内购说明|#', '支付帮助|#']],
].map(item => ({
  icon: item[0],
  title: item[1],
  links: item[2].map(link => ({
    title: link.split('|')[0],
    url: link.split('|')[1]
  }))
}));
const footerLinks2 = [
  ['shipping', '配送', ['配送运费|#', '自提说明|#']],
  ['peoples', '企业合作', ['申请⼊口|#']]
].map(item => ({
  icon: item[0],
  title: item[1],
  links: item[2].map(link => ({
    title: link.split('|')[0],
    url: link.split('|')[1]
  }))
}));


const tabbarHome = {
  icon: require('@/assets/tabbar/home.png'),
  iconSelect: require('@/assets/tabbar/home-select.png'),
  url: 'home',
  name: '首页',
}

const tabbars = [
  tabbarHome,
  {
    icon: require('@/assets/tabbar/list.png'),
    iconSelect: require('@/assets/tabbar/list-select.png'),
    url: 'list',
    name: '列表',
  },
  {
    icon: require('@/assets/tabbar/cart.png'),
    iconSelect: require('@/assets/tabbar/cart-select.png'),
    url: 'cart-index',
    name: '购物车',
  },
  {
    icon: require('@/assets/tabbar/member.png'),
    iconSelect: require('@/assets/tabbar/member-select.png'),
    url: 'member-index',
    name: '我的',
  },
]


export default {
  name: 'MemberLayout',
  components: {
    AppMain
  },
  data() {
    return {
      showSearchInput: false,
      footerLinks,
      footerLinks2,
      keyword: '',
      logoUrl: config.siteLogo,
      showTabbar: false,
      showHelp: false,
    }
  },
  computed: {
    ...cartMapGetters([
      'cartNum'
    ]),
    ...mapState('activity', {
      activityId: state => state.activityId
    }),
    tabbars() {
      let list = Object.assign([], tabbars)
      if (!this.activity.homeShow) {
        list.splice(0, 1)
      }
      return list
    },
    tabbarIndex() {
      const { name } = this.$route
      const index = lodash.findIndex(this.tabbars, item => {
        return item.url == name
      })
      return index
    },
    isShowCates() {
      const notShowCate = ['/home']
      let isHide = false
      isHide = notShowCate.find(item => {
        return item == this.$route.path
      })

      if (isHide) {
        return false
      }

      return true
    }
  },
  watch: {
    $route() {
      this.showKeyword()
    }
  },
  created() {
    this.showKeyword()
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' })
    },
    showSearchInputView() {
      this.keyword = ''
      this.showSearchInput = true
    },
    handleSearch() {
      if (this.keyword != '') {
        this.showSearchInput = false
        this.$router.push({ name: 'product-search', query: { keyword: this.keyword } })
      }
    },
    updateActivity() {
      this.$store.dispatch('activity/setId', this.activityId)
    },
    showKeyword() {
      const query = this.$route.query
      if (query && query.keyword) {
        this.keyword = query.keyword
      } else {
        this.keyword = ''
      }
    },
    openOLService() {
      ysf.open()
    }
  },
  updated() {
    const { showTabbar = false, showHelp = false } = this.$route.meta
    setTimeout(()=> {
      this.showHelp = showHelp
    }, 500)
    this.showTabbar = showTabbar
  },
  mounted() {
    const { showTabbar = false, showHelp = false } = this.$route.meta
    setTimeout(()=> {
      this.showHelp = showHelp
    }, 500)
    this.showTabbar = showTabbar
    this.updateActivity();
  }
}
</script>
